import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const InlineCode = makeShortcode("InlineCode");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`An `}<inlineCode parentName="p">{`AnchoredOverlay`}</inlineCode>{` provides an anchor that will open a floating overlay positioned relative to the anchor.
The overlay can be opened and navigated using keyboard or mouse.`}</p>
    <p>{`See also `}<a parentName="p" {...{
        "href": "/Overlay#positioning"
      }}>{`Overlay positioning`}</a>{`.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State default={false}>
  {([isOpen, setIsOpen]) => {
    const openOverlay = React.useCallback(() => setIsOpen(true), [setIsOpen])
    const closeOverlay = React.useCallback(() => setIsOpen(false), [setIsOpen])
    return (
      <AnchoredOverlay
        renderAnchor={anchorProps => (
          <Button {...anchorProps} trailingIcon={TriangleDownIcon}>
            Click me to open
          </Button>
        )}
        open={isOpen}
        onOpen={openOverlay}
        onClose={closeOverlay}
      >
        <Box display="flex" flexDirection="column" maxWidth="300px" padding={2}>
          <p>
            This menu automatically receives a focus trap and focus zone. Use up/down keys to navigate between buttons
          </p>
          <Button mb={1}>Button 1</Button>
          <Button mb={1}>Button 2</Button>
          <Button>Button 3</Button>
        </Box>
      </AnchoredOverlay>
    )
  }}
</State>
`}</code></pre>
    <h2>{`Props`}</h2>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="open" type="boolean" defaultValue="false" description="Determines whether the overlay portion of the component should be shown or not." mdxType="PropsTableRow" />
  <PropsTableRow name="onOpen" type="(gesture: 'anchor-click' | 'anchor-key-press') => unknown" description='A callback that is called whenever the overlay is currently closed and an "open gesture" is detected.' mdxType="PropsTableRow" />
  <PropsTableRow name="onClose" type="(gesture: 'anchor-click' | 'click-outside' | 'escape') => unknown" description='A callback that is called whenever the overlay is currently open and a "close gesture" is detected.' mdxType="PropsTableRow" />
  <PropsTableRow name="renderAnchor" type="<T extends React.HTMLAttributes<HTMLElement>>(props: T) => JSX.Element" description={<>
        A custom function component used to render the anchor element. When renderAnchor is null, an anchorRef is
        required.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="anchorRef" type="React.RefObject<HTMLElement>" description={<>
        An override to the internal <InlineCode mdxType="InlineCode">renderAnchor</InlineCode> ref that will be used to position the overlay.
        When <InlineCode mdxType="InlineCode">renderAnchor</InlineCode> is
        <InlineCode mdxType="InlineCode">null</InlineCode>, this can be used to make an anchor that is detached from <InlineCode mdxType="InlineCode">
          AnchoredOverlay
        </InlineCode>.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="anchorId" type="string" description="An override to the internal id that will be passed to the anchor." mdxType="PropsTableRow" />
  <PropsTableRow name="side" type={`| 'inside-top' 
| 'inside-bottom' 
| 'inside-left' 
| 'inside-right' 
| 'inside-center' 
| 'outside-top' 
| 'outside-bottom' 
| 'outside-left' 
| 'outside-right'`} defaultValue="'outside-bottom'" mdxType="PropsTableRow" />
  <PropsTableRow name="align" type="'start' | 'center' | 'end'" defaultValue="'start'" mdxType="PropsTableRow" />
  <PropsTableRow name="overlayProps" type={<>
        Partial&lt;<Link href="/react/Overlay#props" mdxType="Link">OverlayProps</Link>&gt;
      </>} description={<>
        Props to be spread on the internal <InlineCode mdxType="InlineCode">Overlay</InlineCode> component.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="focusTrapSettings" type={<>
        Partial&lt;<Link href="/react/focusTrap#focustraphooksettings-interface" mdxType="Link">FocusTrapHookSettings</Link>&gt;
      </>} description={<>
        Settings to apply to the focus trap on the internal <InlineCode mdxType="InlineCode">Overlay</InlineCode> component.
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="focusZoneSettings" type={<>
        Partial&lt;<Link href="/react/focusZone#focuszonehooksettings-interface" mdxType="Link">FocusZoneHookSettings</Link>&gt;
      </>} description={<>
        Settings to apply to the focus zone on the internal <InlineCode mdxType="InlineCode">Overlay</InlineCode> component.
      </>} mdxType="PropsTableRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: false,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      